export const cookieConsentDisabled: boolean = true;
